/**
 * PhotoUpload class
 * Handles file upload/preview related logic of the photo block
 */
import toArray from 'arrayify';
import BEM from 'bem.js';


export const BLOCK_PHOTO = 'photo';

const ELEMENT_UPLOAD = 'upload';

const ELEMENT_DISPLAY = 'display';

const PHOTOS = BEM.getBEMNodes(BLOCK_PHOTO);


/**
 * PhotoUpload class
 * Handles file upload/preview related logic of the photo block
 * @class
 */
export class PhotoUpload {
    /**
     * Constructor method
     * Gets called when class get instantiated
     * @param {HTMLElement} photo
     */
    constructor(photo) {
        this.setUpAddChangeFileInput(photo);
    }

    /**
     * Binds change event of ELEMENT_UPLOAD in photo to this.setPreviewImage();
     * @param {HTMLElement} photo
     */
    setUpAddChangeFileInput(photo) {
        let fileInput = BEM.getChildBEMNode(photo, BLOCK_PHOTO, ELEMENT_UPLOAD);

        if (fileInput) {
            fileInput.addEventListener('change', this.setPreviewImage.bind(this, photo, fileInput));
        }
    }

    /**
     * Reads the file in fileInput as dataURL and applies it to ELEMENT_DISPLAY
     * @param {HTMLElement} photo
     * @param {HTMLInputElement} fileInput
     */
    setPreviewImage(photo, fileInput) {
        let reader = new FileReader();

        reader.onload = (e) => {
            let image = BEM.getChildBEMNode(photo, BLOCK_PHOTO, ELEMENT_DISPLAY);
            image.src = e.target.result;
        };

        reader.readAsDataURL(fileInput.files[0]);

    }
}


toArray(PHOTOS).map((photo) => new PhotoUpload(photo));



// WEBPACK FOOTER //
// ./src/my_artis/js/components/photo-upload.js